import { Button, Divider, Paper, Stack } from "@mui/material";
import { AdvancedSettingDrawer, BundleViewSwitch, OrdersTableTabs } from "../components";
import { ACTIVE_ORDERS_TABLE_TAB_KEY, Filter, IS_BUNDLE_VIEW, ORDERS_SEARCH_OPTIONS_LS, ORDERS_TABLE_TABS } from "../constants";
import { useEffect, useState } from "react";
import { OrdersTable } from "../components/OrdersTable/OrdersTable";
import { getOrdersSearchFilters } from "../utils";
import { ManualCreateOrderItemDrawer } from "../components/OrdersTable/ManualCreateShipmentDrawer/ManualCreateOrderDrawer";

export const OrdersModule = () => {
  const [bundleView, setBundleView] = useState<boolean>(JSON.parse(localStorage.getItem(IS_BUNDLE_VIEW)) || false);
  const [openAdvancedSettings, setOpenAdvancedSettings] = useState(false);
  const [activeOrdersTabId, setActiveOrdersTabId] = useState(
    localStorage.getItem(ACTIVE_ORDERS_TABLE_TAB_KEY) || ORDERS_TABLE_TABS.UN_PICKED.value
  );
  const [searchFilters, setSearchFilters] = useState<Filter[]>(getOrdersSearchFilters(activeOrdersTabId));

  // TODO: Add custom text search capability
  const [searchSortOption, setSearchSortOption] = useState<{ direction: "asc" | "desc"; field: string } | undefined>({
    direction: "desc",
    field: "appImportDateTime",
  });
  const [searchOrdersCustomText, setSearchOrdersCustomText] = useState<string>("");
  const [ordersCustomSearchType, setOrdersCustomSearchType] = useState("PRODUCT");
  const [isManualShipmentItemDrawerOpen, setIsManualShipmentItemDrawerOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(
      ORDERS_SEARCH_OPTIONS_LS,
      JSON.stringify({ searchOptions: { filters: searchFilters, sortOptions: searchSortOption } })
    );
  }, [searchFilters, searchSortOption, activeOrdersTabId]);

  useEffect(() => {
    // Set default active tab on component mount
    !activeOrdersTabId && localStorage.setItem(ACTIVE_ORDERS_TABLE_TAB_KEY, ORDERS_TABLE_TABS.UN_PICKED.value);
  }, []);

  const handleBundleViewUpdate = () => {
    localStorage.setItem(IS_BUNDLE_VIEW, JSON.stringify(!bundleView));
    setBundleView(!bundleView);
  };

  // trigger on custom search in orders page
  const onCustomOrderShipmentsSearch = (customSearchText, searchType) => {
    setSearchOrdersCustomText(() => customSearchText);
    setOrdersCustomSearchType(() => searchType);
  };

  // trigger on tab value change in orders page
  const onOrdersPageTabValueChange = (newTabValue) => {
    localStorage.removeItem(ORDERS_SEARCH_OPTIONS_LS);
    setActiveOrdersTabId(newTabValue);
  };

  const handleAdvancedSettingsClose = ({ sortByField, sortType, filters }) => {
    // Note - need to joing preset filter values as api is requiring it as a comma separated string rather than array of strings
    setSearchFilters(filters);
    sortByField && sortType && setSearchSortOption({ direction: sortType, field: sortByField });
    setOpenAdvancedSettings((prevOnOpenTableDetails) => !prevOnOpenTableDetails);
  };

  useEffect(() => {
    setSearchFilters(getOrdersSearchFilters(activeOrdersTabId));
  }, [activeOrdersTabId]);

  const handleOnclickCreateItemShipmentButton = () => {
    setIsManualShipmentItemDrawerOpen(true);
  };
  return (
    <>
      <Paper sx={{ padding: "16px", overflow: "hidden" }}>
        <Stack direction="row" alignItems="center" justifyContent={"end"} spacing={2}>
          {activeOrdersTabId === ORDERS_TABLE_TABS.UN_PICKED.value && (
            <Stack>
              <Button
                onClick={handleOnclickCreateItemShipmentButton}
                variant="outlined"
                sx={{ padding: "2px", fontSize: "0.71rem" }}
              >
                Create Order
              </Button>
            </Stack>
          )}
          <Divider orientation="vertical" variant="middle" flexItem />
          <BundleViewSwitch isBundleView={bundleView} onChange={handleBundleViewUpdate} />
        </Stack>

        {/* Order table tabs */}
        <OrdersTableTabs
          onAdvancedSettingsOpen={() => setOpenAdvancedSettings((prevOnOpenTableDetails) => !prevOnOpenTableDetails)}
          onOrdersCustomSearch={(customText, searchType) => onCustomOrderShipmentsSearch(customText, searchType)}
          onOrdersTableTabChange={(newTabValue) => onOrdersPageTabValueChange(newTabValue)}
        />

        {/* Advanced settings drawer */}
        {openAdvancedSettings && (
          <AdvancedSettingDrawer
            open={openAdvancedSettings}
            page={"ORDERS"}
            searchFilters={{ searchOptions: { filters: searchFilters } }}
            onSaveOrCancelFilters={() => setOpenAdvancedSettings((prevOnOpenTableDetails) => !prevOnOpenTableDetails)}
            onSaveAndApplyFilters={({ sortByField, sortType, filters }) => {
              handleAdvancedSettingsClose({ sortByField, sortType, filters });
            }}
          />
        )}

        {/* Orders table */}
        <OrdersTable
          bundleView={bundleView}
          searchFilters={searchFilters}
          ordersCustomSearchType={ordersCustomSearchType}
          searchOrdersCustomText={searchOrdersCustomText}
          searchSortOption={searchSortOption}
        />

        <ManualCreateOrderItemDrawer
          open={isManualShipmentItemDrawerOpen}
          onClose={() => setIsManualShipmentItemDrawerOpen(false)}
        />
      </Paper>
    </>
  );
};
